import Tenant from "./Tenant";
import Site from "./Site";

export default class UserRoleResponse {
  constructor(
    public code: string,
    public displayName: string,
    public tenant?: Tenant,
    public site?: Site,
  ) { }
}